import type { CardType } from '../types';

const SUPPORTED_CARD_TYPES = new Set<string>([
  'character',
  'support',
  'environment',
]);

type CardLike = {
  characterData?: {
    cardType?: unknown;
  } | null;
};

export const isSupportedCardType = (value: unknown): value is CardType =>
  typeof value === 'string' && SUPPORTED_CARD_TYPES.has(value);

export const isSupportedCard = <T extends CardLike>(card: T | null | undefined): card is T =>
  isSupportedCardType(card?.characterData?.cardType);

export const filterSupportedCards = <T extends CardLike>(cards: T[]): T[] =>
  cards.filter(isSupportedCard);
